import { useAppSelector } from "../redux/hooks";
import { useGetSubscriptionQuery } from "../redux/services/subscription";

const useSubscription = () => {
  const accountId = useAppSelector(
    (state) => state.user.selectedAccount?.accountId ?? null
  );

  const {
    data: subscription,
    isLoading,
    isUninitialized,
    isError,
  } = useGetSubscriptionQuery(
    { accountId },
    { skip: !accountId }
  );

  return {
    accountId,
    subscription,
    isLoading,
    isUninitialized,
    isError,
  };
};

export default useSubscription;
